//define a function
function hamburger__click() {
  if ($(".jsHamburger").length > 0) {
    $("header .jsHamburger").on("click", function (e) {
      e.preventDefault();
      $("body").toggleClass("is-menu-visible");
    });
    $(document).click(function (e) {
      var container = $("header");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.parents("body").removeClass("is-menu-visible");
      }
    });
  }
}

//Image to SVG
function imgToSvg() {
  let convertImages = (query, callback) => {
    let images = document.querySelectorAll("img.svg");
    images.forEach((image) => {
      fetch(image.src)
        .then((res) => res.text())
        .then((data) => {
          let parser = new DOMParser();
          let svg = parser
            .parseFromString(data, "image/svg+xml")
            .querySelector("svg");
          svg.setAttribute(
            "viewBox",
            "0 0 " +
              svg.getAttribute("width") +
              " " +
              svg.getAttribute("height"),
          );
          if (image.id) svg.id = image.id;
          if (image.className) svg.classList = image.classList;
          image.parentNode.replaceChild(svg, image);
        })
        .then(callback);
    });
  };
  convertImages("img");
}

// Header sticky on scroll
let lastScrollTop = 0;
const headerSticky = () => {
  if ($(".header").length > 0) {
    let scrollTop = $(window).scrollTop();
    const header = $(".header");

    if (scrollTop > 10) {
      header.addClass("is-sticky");
    } else {
      header.removeClass("is-sticky");
    }
    lastScrollTop = scrollTop;
  }
};

// keenslider navigation
function navigation(slider) {
  let wrapper, dots, arrowLeft, arrowRight;

  function markup(remove) {
    wrapperMarkup(remove);
    dotMarkup(remove);
    arrowMarkup(remove);
  }

  function removeElement(elment) {
    elment.parentNode.removeChild(elment);
  }
  function createButton(className) {
    var div = document.createElement("button");
    var classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }
  function createDiv(className) {
    var div = document.createElement("div");
    var classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }

  function arrowMarkup(remove) {
    if (remove) {
      removeElement(arrowLeft);
      removeElement(arrowRight);
      return;
    }
    arrowLeft = createButton("arrow arrow--left");
    arrowLeft.setAttribute("tabindex", "0");
    arrowLeft.setAttribute("aria-label", "previous slide");
    arrowLeft.setAttribute("role", "button");
    arrowLeft.addEventListener("click", () => slider.prev());
    arrowLeft.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        arrowLeft.click();
      }
    });
    arrowRight = createButton("arrow arrow--right");
    arrowRight.setAttribute("tabindex", "0");
    arrowRight.setAttribute("aria-label", "next slide");
    arrowRight.setAttribute("role", "button");
    arrowRight.addEventListener("click", () => slider.next());
    arrowRight.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        arrowRight.click();
      }
    });

    innerWrapper.appendChild(arrowLeft);
    innerWrapper.appendChild(arrowRight);
  }

  function wrapperMarkup(remove) {
    if (remove) {
      var parent = wrapper.parentNode;
      while (wrapper.firstChild)
        parent.insertBefore(wrapper.firstChild, wrapper);
      removeElement(wrapper);
      return;
    }
    wrapper = createDiv("slider-wrapper");
    innerWrapper = createDiv("slider-navigation");
    slider.container.parentNode.appendChild(wrapper);
    wrapper.appendChild(slider.container);
    wrapper.appendChild(innerWrapper);
  }

  function dotMarkup(remove) {
    if (remove) {
      removeElement(dots);
      return;
    }
    dots = createDiv("dots");
    slider.track.details.slides.forEach((_e, idx) => {
      var dot = createButton("dot");
      dot.setAttribute("tabindex", "0");
      dot.setAttribute("aria-label", "navigate to slide " + (idx + 1));
      dot.addEventListener("click", () => slider.moveToIdx(idx));
      dot.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          dot.click();
        }
      });
      dots.appendChild(dot);
    });
    innerWrapper.appendChild(dots);
  }

  function updateClasses() {
    var slide = slider.track.details.rel;
    slide === 0
      ? arrowLeft.classList.add("arrow--disabled")
      : arrowLeft.classList.remove("arrow--disabled");
    slide === slider.track.details.slides.length - 1
      ? arrowRight.classList.add("arrow--disabled")
      : arrowRight.classList.remove("arrow--disabled");
    Array.from(dots.children).forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add("dot--active")
        : dot.classList.remove("dot--active");
    });
  }

  slider.on("created", () => {
    markup();
    updateClasses();
  });
  slider.on("optionsChanged", () => {
    console.log(2);
    markup(true);
    markup();
    updateClasses();
  });
  slider.on("slideChanged", () => {
    updateClasses();
  });
  slider.on("destroyed", () => {
    markup(true);
  });
}
// keenslider init
function newsSlider() {
  if ($(".fhw.slider").length > 0) {
    var slider = new KeenSlider(
      "#newsSlider",
      {
        breakpoints: {
          "(min-width: 500px)": {
            slides: { perView: 2, spacing: 10 },
          },
          "(min-width: 991px)": {
            slides: { perView: 3.125, spacing: 32, origin: "center" },
          },
        },
        loop: true,
        slides: { perView: 1.12, spacing: 10 },
      },
      [navigation],
    );
  }
}

function current__year() {
  if ($("#year").length > 0) {
    var date = new Date();
    var year = date.getFullYear();
    document.getElementById("year").innerHTML = year;
  }
}

//Cursor
function cursorClick() {
  $("a").each(function () {
    let href = $(this).attr("href");
    if (!href || href === "#" || href === "#0" || href === "#!") {
      $(this).addClass("is-unclickable");
    }
  });
}

$(document).ready(function () {
  // imgToSvg();
  current__year();
});

$(window).on("load", function () {
  // hamburger__click();
  // newsSlider();
  cursorClick();
});
